import React, { useState } from 'react';
import { IInvitation } from 'types';
import Spinner from 'components/spinner';
import styles from './invitationList.scss';
import InvitationDetails from './InvitationDetails';

export interface IProps {
  loading?: boolean;
  showStatus?: boolean;
  emptyText?: string;
  className?: string;
  invitations: IInvitation[];
  onItemClick?(item: any): void;
  deleteInvitation?(invitationId: string): void;
  deleteUserFromFamily?(userId: string, familyId: string): void;
}

const InvitationList = (props: IProps) => {
  const {
    className,
    showStatus,
    invitations,
    loading,
    emptyText,
    deleteUserFromFamily,
    deleteInvitation,
    onItemClick,
  } = props;

  const [showDeleteConfirm, setConfirm] = useState(false);
  const [showDetails, setShowDetails] = useState(null);

  const openDeleteConfirm = () => setConfirm(true);
  const closeDeleteConfirm = () => setConfirm(false);

  const closeDetails = () => setShowDetails(null);
  const openDetails = (invitation: IInvitation) => setShowDetails(invitation);

  const viewDashboard = () => {
    if (onItemClick) {
      onItemClick(showDetails);
    }
  };

  const handleDelete = (invitationToDelete) => {
    if (invitationToDelete) {
      if (invitationToDelete.processed) {
        deleteUserFromFamily(
          invitationToDelete.invitedUserId,
          invitationToDelete.sk,
        );
      }
      deleteInvitation(invitationToDelete.id);
      closeDetails();
      closeDeleteConfirm();
    }
  };

  return (
    <div className={classnames(styles.container, className)}>
      <InvitationDetails
        onClose={closeDetails}
        invitation={showDetails}
        open={!!showDetails}
        showConfirm={showDeleteConfirm}
        showStatus={showStatus}
        closeDeleteConfirm={closeDeleteConfirm}
        onDeleteInvitation={handleDelete}
        openDeleteConfirm={openDeleteConfirm}
        viewDashboard={viewDashboard}
      />
      <Spinner className={styles.loading} loading={loading} />
      {invitations.length === 0 ? (
        <div className={styles.emptyText}>{emptyText}</div>
      ) : (
        invitations.map((invitation, key) => {
          const { name } = invitation;

          return (
            <div
              key={`invitation_${key}`}
              className={styles.item}
              onClick={() => openDetails(invitation)}
            >
              {name}
            </div>
          );
        })
      )}
    </div>
  );
};

export default InvitationList;
